<template>
  <div>
    <video playsinline autoplay muted loop class="bgvideo"
    :src="video" type="video/mp4">
    </video>
    <div class="overlay"></div>
    <p class="location hide">
      <img src="~@/assets/img/location.svg" alt="map-marker" class="location-icon"
      />{{ location }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'HomeBanner',
  props: ['video', 'location'],
};
</script>
